import { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Label,
  Button,
  Input,
  FormFeedback,
  Col,
  Row,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

import { deleteClient } from "connection/backend";

const ClientDelete = (props) => {
  const redirect = () => {
    props.resetFunction();
  };

  const [clientDetail, setClientDetail] = useState(null);

  const onSubmit = (e) => {
    e.preventDefault();
    delData(props.client.code);
  };

  const delData = async (id) => {
    try {
      const response = await deleteClient(id);
      if (response.status === 200) {
        props.toggleFunction();
        setClientDetail(response.data.detail);
      }
    } catch (error) {
      console.log("Error al eliminar el cliente.");
    }
  };

  return (
    <>
      <Modal
        isOpen={props.modal}
        toggle={props.toggleFunction}
        centered={true}
        backdrop="static"
        size="ms"
      >
        <ModalHeader
          toggle={props.toggleFunction}
          className="justify-content-center"
        >
          Eliminar cliente
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={onSubmit}>
            <Row className="justify-content-md-center mb-1">
              <Col lg={10}>
                <center>
                  <p>
                    ¿Está seguro/a que quiere eliminar el cliente{" "}
                    <b>{props.client.full_name}</b>?
                  </p>
                </center>
              </Col>
            </Row>

            <Row className="justify-content-md-center">
              <Col lg={4}>
                <Button color="primary" className="btn col-12" type="submit">
                  Sí
                </Button>
              </Col>
              <Col lg={4}>
                <Button
                  color="secondary"
                  className="btn col-12"
                  onClick={() => props.toggleFunction()}
                >
                  No
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
      {clientDetail ? (
        <SweetAlert
          title="¡Hecho!"
          success
          showConfirm={true}
          onConfirm={() => {
            redirect();
          }}
        >
          El cliente {props.client.full_name} se ha eliminado correctamente.
        </SweetAlert>
      ) : null}
    </>
  );
};

export default ClientDelete;
